import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Alert",
  [
    [
      "path",
      {
        d: "M12,3.34C7.03,3.34,3,7.37,3,12.34s4.03,9,9,9,9-4.03,9-9S16.97,3.34,12,3.34ZM1,12.34C1,6.26,5.92,1.34,12,1.34s11,4.92,11,11-4.92,11-11,11S1,18.41,1,12.34ZM12,7.34c.55,0,1,.45,1,1v4c0,.55-.45,1-1,1s-1-.45-1-1v-4c0-.55.45-1,1-1ZM11,16.34c0-.55.45-1,1-1h.01c.55,0,1,.45,1,1s-.45,1-1,1h-.01c-.55,0-1-.45-1-1Z",
      },
    ],
  ],
  "currentColor"
);
